// Returns a fresh App Bridge session token (JWT) for authenticating
// requests to the Pack Perfect worker. The global `shopify` object is
// created by the app-bridge.js script loaded in index.html.
export async function getSessionToken() {
  if (!window.shopify || typeof window.shopify.idToken !== 'function') {
    throw new Error('Shopify App Bridge is not initialized');
  }
  return window.shopify.idToken();
}
